/* eslint-disable ember/no-controller-access-in-routes, warp-drive/no-legacy-request-patterns */
// Extends From
import Route from '@ember/routing/route';
// Ember Imports
import { isArray } from '@ember/array';
import { isEmpty } from '@ember/utils';
import { service } from '@ember/service';
// External imports
import PersonType from '@linc-technologies/linced-common/enums/person-type';
import { compact, mapBy } from '@linc-technologies/linced-common/utils/arrays';
import { hash } from '@linc-technologies/linced-common/utils/promise';
import moment from 'moment/moment';

export default class PersonRoute extends Route {
  // Services
  @service
  features;

  @service
  store;

  model(params) {
    let person = this.store.findRecord('person', params.person_id);
    let sickbayPage = null;
    let sickbayVisits = [];
    if (this.features.heroSuiteEnabled) {
      let date = moment().format('YYYY-MM-DD');
      sickbayPage = this.store
        .query('posts/page', { isSickbay: true })
        .then((pages) => {
          return pages[0];
        });
      sickbayVisits = this.store.query('attendance/sickbay-visit', {
        date,
        current: true,
        learnerId: params.person_id,
      });
    }

    return hash({
      person,
      // entryDate is resolved here (rather than left to the template) because
      // Person#enrolment returns a promise when the record is not in the store;
      // awaiting it is the only way to reach its resolved `entryDate`.
      entryDate: person.then(async (resolvedPerson) => {
        let enrolment = await resolvedPerson.enrolment;
        return enrolment ? enrolment.entryDate : null;
      }),
      badges: this.store.query('goals/badge', {
        personId: params.person_id,
      }),
      sickbayPage,
      sickbayVisits,
      medications: this.store
        .findAll('medical/medication')
        .then((medications) => {
          return medications.filter((medication) => !medication.deleted);
        }),
      batches: this.store.findAll('medical/batch'),
      schedules: this.store.findAll('medical/schedule'),
    });
  }

  afterModel(model) {
    if (model.person.type === PersonType.LEARNER) {
      let contacts = model.person.get('learner.contacts');
      if (isArray(contacts)) {
        let caregiverIds = compact(mapBy(contacts, 'caregiverId'));
        if (caregiverIds.length > 0) {
          // If we have caregivers to look up, return the query so that the
          // route transition will await the response.
          return this.store.query('person', {
            people: JSON.stringify(caregiverIds),
          });
        }
      }
    }
  }

  setupController(controller, model) {
    super.setupController(...arguments);
    // Push the Learner's classmates (if known/present) into the People Selector as the default list.
    if (!isEmpty(model) && !isEmpty(model.person)) {
      let homeroom = model.person.get('homeroom');
      if (homeroom && homeroom.get('currentLearners.length')) {
        this.controllerFor('application').setPeopleSelectorDefault(
          mapBy(homeroom.currentLearners, 'person'),
        );
      }
    }
  }

  deactivate() {
    super.deactivate(...arguments);
    // Clear/reset the People Selector's default list.
    this.controllerFor('application').setPeopleSelectorDefault([]);
  }
}
